import {
  SET_APP_LANGUAGE,
  SET_LOGIN_DETAILS,
  SET_USER_PROFILE,
  SET_PROFILE_CHOOSEN,
  SET_PROFILE_IMAGE,
  SET_ACCOUNT_LIST,
  SET_LOAN_LIST,
  SET_DEPOSIT_LIST,
  SET_LOGIN_VERIFY_DETAILS,
  SET_TXN_PENDING_COUNT,
  SET_SERVER_KEY,
  SET_SHARED_KEY,
  SET_DEVICE_ID,
  SET_MENU_OPEN,
  SET_ACCESS_LIST,
  SET_ROLE_PERMISSION,
  SET_SERVICE_LOADER,
  SET_SELECTED_ACCOUNT,
  SET_TRANSACTION_CURRENCY_LIST,
  SET_CURRENT_ACC_DETAILS,
  SET_DEFAULT_PATH,
  SET_QUICK_LINKS_DATA,
  SET_SESSION_TIMER,
  SET_OTP_TIMER,
  SET_QUICK_SEARCH,
  RESET_ALL_STATE,
  SET_COUNTRY_CODES,
} from "../constants";

const initialState = {
  language: "en",
  loginDetails: {},
  profileDetails: {},
  permissionList: [],
  profileChoosen: false,
  profilePhoto: null,
  accountList: [],
  depositList: [],
  loanList: [],
  loginVerifyDetails: {},
  txnPendingCounts: 0,
  sharedKey: "",
  serverKey: "",
  menuOpen: false,
  accessList: {},
  mode: "AA",
  serviceLoader: false,
  selectedAccount: {},
  currentAccountDetails: {},
  transactionCurrencyList: [],
  deviceId: "",
  quickLinksData: [],
  otpTimerDetails: 0,
  sessionTimeOut: 0,
  quickSearch:undefined,
  resetAll: false,
  countryCodesList: [],
  
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_APP_LANGUAGE:
      return { ...state, language: payload };
    case SET_LOGIN_DETAILS:
      return { ...state, loginDetails: payload };
    case SET_USER_PROFILE:
      return { ...state, profileDetails: payload };
    case SET_PROFILE_CHOOSEN:
      return { ...state, profileChoosen: payload };
    case SET_PROFILE_IMAGE:
      return { ...state, profilePhoto: payload };
    case SET_ACCOUNT_LIST:
      return { ...state, accountList: payload };
    case SET_DEPOSIT_LIST:
      return { ...state, depositList: payload };
    case SET_LOAN_LIST:
      return { ...state, loanList: payload };

    case SET_LOGIN_VERIFY_DETAILS:
      return { ...state, loginVerifyDetails: payload };

    case SET_TXN_PENDING_COUNT:
      return { ...state, txnPendingCounts: payload };

    case SET_DEVICE_ID:
      return { ...state, deviceId: payload };

    case SET_SHARED_KEY:
      return { ...state, sharedKey: payload };

    case SET_SERVER_KEY:
      return { ...state, serverKey: payload };

    case SET_MENU_OPEN:
      return { ...state, menuOpen: payload };

    case SET_ACCESS_LIST:
      return { ...state, accessList: payload };

    case SET_ROLE_PERMISSION:
      return { ...state, mode: payload };

    case SET_SERVICE_LOADER:
      return { ...state, serviceLoader: payload };

    case SET_SELECTED_ACCOUNT:
      return { ...state, selectedAccount: payload };

    case SET_TRANSACTION_CURRENCY_LIST:
      return { ...state, transactionCurrencyList: payload };

    case SET_CURRENT_ACC_DETAILS:
      return { ...state, currentAccountDetails: payload };

    case SET_QUICK_LINKS_DATA:
      return { ...state, quickLinksData: payload };

    case SET_OTP_TIMER:
      return { ...state, otpTimerDetails: payload };

    case SET_SESSION_TIMER:
      return { ...state, sessionTimeOut: payload };

      case SET_QUICK_SEARCH:
      return { ...state, quickSearch: payload };
      case RESET_ALL_STATE:
      return { ...state, resetAll: payload };
      case SET_COUNTRY_CODES:
      return { ...state, countryCodesList: payload };
    default:
      return state;
  }
};
